import styled from 'styled-components';

export const BrandHeaderStyle = styled.div`
  padding: 8px 16px 0;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  max-width: 376px;
  background: white;
  width: 100%;
  margin: 0 auto;
  z-index: 2;

  .language-picker-wrapper {
    position: fixed;
    top: -15px;
    right: 0;
    width: 100%;
    max-width: 520px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    z-index: 30;
  }

  .brand-header-logo {
    height: 40px;
    max-width: 120px;
    img {
      max-width: 140px;
      height: 100%;
      width: auto;
      object-fit: contain;
    }
  }
  .brand-header-text {
    color: ${(props) => props.theme.primary.primary50};
    padding-left: 16px;
    margin-left: 16px;
    position: relative;
    &:before {
      content: '';
      width: 2px;
      background: ${(props) => props.theme.primary.primary50};
      height: 18px;
      position: absolute;
      left: 0;
      top: 3px;
    }
  }
`;
